import {
    FEATURE_PRIORITY_SUPPORT,
    FEATURE_STANDARD_SUPPORT,
    hasFeatureFlag,
    PersonsOrganisationDto
} from '@flyfreely-portal-ui/flyfreely';

/**
 * Compute the hsmode value for the support widget
 * @param organisation the current organisation object
 * @returns a value of 0, 1 or 2
 */
export function computeHubSpotMode(
    organisation: PersonsOrganisationDto
): 0 | 1 | 2 {
    if (hasFeatureFlag(organisation, FEATURE_PRIORITY_SUPPORT)) {
        return 2;
    } else if (hasFeatureFlag(organisation, FEATURE_STANDARD_SUPPORT)) {
        return 1;
    } else {
        return 0;
    }
}
